import { useEffect, useMemo, useRef } from 'react'

import { debounce } from 'lodash'

export const useDebouncedCallback = <TArgs extends Array<any>, TReturn>(
	func: (...args: TArgs) => TReturn,
	delayMs: number,
) => {
	const funcRef = useRef(func)
	useEffect(() => {
		funcRef.current = func
	}, [func])

	return useMemo(() => debounce((...args: TArgs) => funcRef.current(...args), delayMs), [delayMs])
}
